import { useEffect } from "react";
import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";

// Inline alert above the chat for pre-stream / pre-send errors (in-stream errors
// stay in the bubble via AgentErrorMessage). Dismisses on any user action —
// pointerdown covers mouse + touch, keydown covers the keyboard — or the close button.
const DISMISS_EVENTS = ["pointerdown", "keydown"];

const ChatInlineAlert = ({ message, onClose }) => {
  useEffect(() => {
    if (!message) return undefined;
    // Defer attaching so the action that produced the alert doesn't immediately close it.
    const id = setTimeout(() => {
      DISMISS_EVENTS.forEach((evt) => document.addEventListener(evt, onClose));
    }, 0);
    return () => {
      clearTimeout(id);
      DISMISS_EVENTS.forEach((evt) => document.removeEventListener(evt, onClose));
    };
  }, [message, onClose]);

  if (!message) return null;
  return (
    // Match ChatInput's 318px and drop horizontal inset so the alert's left edge is
    // flush with the chat input box (no indent).
    <Box width="318px" spacingInset="200 0">
      <Alert type="error" size="small" onClose={onClose}>
        {message}
      </Alert>
    </Box>
  );
};

export default ChatInlineAlert;
